import { useSpring } from '@react-spring/web';
import type { RefObject } from 'react';
import { useEffect } from 'react';

export const useScroll = ({
  container,
}: {
  container: RefObject<HTMLElement | null>;
}) => {
  const [scrollValues, api] = useSpring(() => ({
    from: {
      scrollX: 0,
      scrollY: 0,
    },
  }));

  useEffect(() => {
    const onScroll = () => {
      api.start({
        scrollX: container.current?.scrollLeft,
        scrollY: container.current?.scrollTop,
      });
    };
    const containerRef = container.current;
    containerRef?.addEventListener('scroll', onScroll);
    return () => {
      containerRef?.removeEventListener('scroll', onScroll);
    };
  }, [container, api]);

  return scrollValues;
};
